var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("test v-select")]),_c('v-select',{attrs:{"placeholder":"Elegri","options":_vm.dataSelect},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }